export default {
  // FAQ & 公告
  GetFaqList: '/aisee/v1/manage/faq/list', // 获取faq列表
  queryFaqLevelConfig: '/aisee/v1/manage/faq/queryFaqLevelConfig', // 获取faq关联状态
  saveFaqLevelConfig: '/aisee/v1/manage/faq/saveFaqLevelConfig', // 保存faq关联状态
  GetFaqGroupList: '/aisee/v1/manage/faq/group/list', // 获取分组列表
  GetFaqModify: '/aisee/v1/manage/faq/modify', // 编辑faq
  GetFaqCreate: '/aisee/v1/manage/faq/create', // 新建faq
  GetGroupModify: '/aisee/v1/manage/faq/group/modify', // 编辑分组
  GetGroupCreate: '/aisee/v1/manage/faq/group/create', // 新建分组
  SetGroupStatus: '/aisee/v1/manage/faq/group/set-status', // 新建分组
  SetFaqHot: '/aisee/v1/manage/faq/set-hot', // 设置热门
  SetFaqStatus: '/aisee/v1/manage/faq/set-status', // 设置状态
  GetFaqOperateRecords: '/aisee/v1/manage/faq/operate-records', // 获取操作记录
  GetTmpsecret: '/aisee/v1/collect/feedbacks/gettmpsecret',
  getTmpSignUrl: '/aisee/v1/manage/tmp-sign-url', // 获取图片上传密钥
  faqUpload: '/aisee/v1/manage/faq/upload', // 上传文件
  getCustomH5List: '/aisee/v1/manage/customH5Setting/GetH5', // 拉取公告/banner 列表
  saveCustomH5: '/aisee/v1/manage/customH5Setting/saveH5', // 修改公告/banner
  ExportFaqs: '/aisee/v1/faqs/export', // 导出FAQ列表
  SyncFaqs: '/aisee/v1/manage/faq/sync', // 批量同步FAQ到其他项目
  // ReplyCard 相关
  SaveReplyCard: '/aisee/v1/replyCard/save',
  ListReplyCard: '/aisee/v1/replyCard/list',
  BindReplyCardToFaq: '/aisee/v1/replyCard/bindFaq',
  SetReplyCardStatus: '/aisee/v1/replyCard/setStatus',
  UpdateReplyCardToClient: '/aisee/v1/replyCard/updateToClient',
};
